<template>
  <div>
    <template v-for='(item,index) in newData'>
      <drag-node :model='item' :allowDrag='allowDrag' :allowDrop='allowDrop' :depth='increaseDepth'
        :defaultText='defaultText' :disableDBClick='disableDBClick' :key='index' 
          :displayCheckBox="displayCheckBox" :displayRadio="displayRadio" 
           :modelRadio="modelRadio" @changeRadio="emitChangeRadio"
           :createNodeFlag="createNodeFlag" :deleteNodeFlag="deleteNodeFlag" :treeName="treeName"
           :isCreateLevel="isCreateLevel" :createLevel="createLevel"
           :isFieldCreateFlag="isFieldCreateFlag" :fieldCreateFlag="fieldCreateFlag" :negativity="negativity"
           :isNotCreateStatus="isNotCreateStatus" :statusNotCreate="statusNotCreate"
            @createNode="emitCreateNode" @deleteNode="emitDeleteNode" @emitCurNodeClicked="emitCurNodeClicked">
        <!-- <slot :nodeName="slotProps.nodeName" :isClicked='slotProps.isClicked'></slot> -->
      </drag-node>
    </template>
  </div>
</template>

<script>
import DragNode from "./DragNode";
export default {
  name: "VueDragTree",
  props: {
    data: Array,
    allowDrag: {
      type: Function,
      default: () => true
    },
    allowDrop: {
      type: Function,
      default: () => true
    },
    defaultText: {
      type: String,
      default: "New Node"
    },
    depth: {
      type: Number,
      default: 0
    },
    disableDBClick: {
      type: Boolean,
      default: false
    },
    displayCheckBox: {
      type: Boolean,
      default: false,
    },
    displayRadio: {
      type: Boolean,
      default: false,
    },
    modelRadio: {
      type: Number,
      default: null,
    },
    createNodeFlag: {
      type: Boolean,
      default: false
    },
    deleteNodeFlag: {
      type: Boolean,
      default: false
    },
    treeName: {
      type: String,
      default: ''
    },
    isCreateLevel: {
      type: Boolean,
      default: false
    },
    createLevel: {
      type: Number,
      default: null
    },
    isFieldCreateFlag: {
      type: Boolean,
      default: false
    },
    fieldCreateFlag: {
      type: String,
      default: ''
    },
    negativity: {
      type: Boolean,
      default: false
    },
    isNotCreateStatus: {
      type: Boolean,
      default: false
    },
    statusNotCreate: {
      type: Array,
      default: null
    },
  },
  computed: {
    increaseDepth() {
      return this.depth + 1;
    },
    newData: {
      // getter
      get() {
        return this.data;
      },
      // setter
      set(newValue) {
        let length = this.data.length;
        for (let i = 0; i < length; i++) {
          this.data.shift(i);
        }
        this.data = Object.assign(this.data, newValue);
      }
    }
  },
  methods: {
    emitCreateNode(model) {
      this.$emit('createNode', model)
    },
    emitChangeRadio(model) {
      this.$emit('changeRadio', model)
    },
    emitDeleteNode(model) {
      this.$emit('deleteNode', model)
    },
    emitCurNodeClicked(model, component) {
      if (this.treeName === '') this.$emit(`current-node-clicked`, model, component);
      else this.$emit(`${this.treeName}-node-clicked`, model, component);
    },
    emitDrag(model, component, e) {
      this.$emit("drag", model, component, e);
    },
    emitDragEnter(model, component, e) {
      this.$emit("drag-enter", model, component, e);
    },
    emitDragLeave(model, component, e) {
      this.$emit("drag-leave", model, component, e);
    },
    emitDragOver(model, component, e) {
      this.$emit("drag-over", model, component, e);
    },
    emitDragEnd(model, component, e) {
      this.$emit("drag-end", model, component, e);
    },
    emitDrop(model, component, e) {
      this.$emit("drop", model, component, e);
    }
  },
  components: {
    DragNode
  }
};
</script>

